import { render, staticRenderFns } from "./WorkWeChatDetail.vue?vue&type=template&id=24a0c86c&"
import script from "./WorkWeChatDetail.vue?vue&type=script&lang=js&"
export * from "./WorkWeChatDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports